export default (start: number, length: number) =>
  Array.from({ length }, (_, i) => start + i);
